import { Component, OnInit, Input } from '@angular/core';
import { Module } from 'src/app/interfaces/module.interface';

@Component({
    selector: 'app-credits-module',
    templateUrl: './credits-module.component.html',
    styleUrls: ['./credits-module.component.scss']
})
export class CreditsModuleComponent implements OnInit {
    @Input() module: Module;
    credits: any;
    activeCreditsCarousel = 0;

    constructor() { }

    ngOnInit() {
        this.credits = this.module.credits;
    }

    crPrev() {
        if (this.activeCreditsCarousel > 0) {
            this.activeCreditsCarousel = this.activeCreditsCarousel - 1;
        } else {
            this.activeCreditsCarousel = 0;
        }
    }

    crNext() {
        var carouselmax = document.getElementsByClassName('cr-carousel-item').length;
        if (this.activeCreditsCarousel < carouselmax - 1) {
            this.activeCreditsCarousel = this.activeCreditsCarousel + 1;
        } else {
            this.activeCreditsCarousel = carouselmax - 1;
        }
    }

    onSwipeLeft(event) {
        event.preventDefault();
        this.crNext();
    }
    
    onSwipeRight(event) {
        event.preventDefault();
        this.crPrev();
    }
}
